import React, {useState} from "react";
import { useForm, Controller} from "react-hook-form";
import Header from "../components/Header";
import { useAxios } from "../services/useAxios";
import {alert, confirm} from "../components/MegConfirmAlert";
import { useTranslation } from 'react-i18next';


export default function Join(props){
    
    const { t } = useTranslation();
    const {register, handleSubmit, trigger, control, formState }= useForm({mode: 'onSubmit',
        defaultValues: { 
            userNm: props.formData.name,     
            email : props.formData.email },
      });
    const{errors} = formState;
    const [request] = useAxios();
    const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    const onSubmit = async data=> {
        const formData = props.formData;
        formData.userNm = data.userNm
        formData.email = data.email
        formData.useStplatAgreAt = props.termsItems.includes(1)?'Y':'N'
        formData.indvdlinfoColctUseAgreAt = props.termsItems.includes(2)?'Y':'N'
        formData.emailRecptnAgreAt = props.termsItems.includes(3)?'Y':'N'
        formData.smsRecptnAgreAt = props.termsItems.includes(4)?'Y':'N'

        const response = await request.post("/app/member/addSocialSignUpAPI", formData);
        if(response.data.resultCode === 200){            
            window.location.href="/JoinSuccess";
        }else{
            alert(response.data.resultMessage);
        }
    }
    return(
        <div>
            <Header type={props.modal?'modal':'black'}  closeFn={props.closeFn} pageTitle={t(`Message.social_sign_up_info_input_title`)}/>    
            <div className="loginArea pd20">
                <form onSubmit={handleSubmit(onSubmit)}>
                <div>
                    <h3 className="joinMent">{t(`Message.social_sign_up_info_input_guide1`)}<br/>{t(`Message.social_sign_up_info_input_guide2`)}</h3>
                    <div className="mt40 pt0">
                        
                            <ul className="dfColG12">
                                <li className="idLi">
                                    <p>{t(`Message.social_sign_up_info_input_name`)} </p>
                                    <input type="text" maxLength={50} placeholder={t(`Message.social_sign_up_info_input_name_hint`)} {...register("userNm", { required:t(`Message.ordrr_form_required_name`)})}/>
                                    {errors.userNm && <p role="alert" className="alertRed">{errors.userNm.message}</p>}
                                </li>
                                
                                <li className="pwLi">
                                    <p>{t(`Message.social_sign_up_info_input_email`)}</p>
                                    <input type="text" maxLength={60} placeholder={t(`Message.ordrr_form_hint_email`)} {...register("email", { required: t(`Message.social_sign_up_info_input_email_required`), pattern: {value: emailRegex, message: t(`Message.social_sign_up_info_input_email_invalid`)}})}/>
                                    {errors.email && <p role="alert" className="alertRed">{errors.email.message}</p>}
                                </li>
                                
                            </ul>                            
                
                    </div>
                </div>
                <button type="submit" className="btn48 cFFF orgB fs16 mt20 fw700">{t(`Message.social_sign_up_info_input_join`)}</button>  
                </form>
            </div>
        </div>
    );
};